// src/aws-exports.js
const awsmobile = {
  Auth: {
    // Note: this nesting is for Amplify v6+
    Cognito: {
      userPoolId:      process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolClientId:process.env.REACT_APP_COGNITO_CLIENT_ID,
      region:          process.env.REACT_APP_COGNITO_REGION,
      loginWith: {
        oauth: {
          domain:         'us-east-1r7xd7bnob.auth.us-east-1.amazoncognito.com',
          scopes:         ['openid','email','profile'],
          redirectSignIn: ['https://main.d2kynujmabkol4.amplifyapp.com/'],
          redirectSignOut:['https://main.d2kynujmabkol4.amplifyapp.com/'],
          responseType:   'code',
          mandatorySignIn: true,
          returnSession: true
        }
      }
    }
  }
};

export default awsmobile;
